import { IBus, FetchFn, IWidgetContext } from '@sg-widgets/platform-api';
import React from 'react';

export type LogFunction = (message: unknown, ...optionalParams: unknown[]) => void;

export interface IWidgetConfiguration {
  environment: string;
  sharedCssUrls: string[];
  fetch: FetchFn;
  bus: IBus;
  context: IWidgetContext;
  useShadowDOM: boolean;
  useGlobalCss: boolean;
  log: LogFunction;
  debug: LogFunction;
  info: LogFunction;
  warn: LogFunction;
  error: LogFunction;
  myConfiguration: <T>() => Promise<T>;
}

/**
 * Options that can be used to adjust how your widgets is configured.
 * Pass it to the `createWidgetConfiguration` function.
 */
export interface WidgetConfigurationOptions {
  /**
   * Disables ShadowDOM usage even in browsers that are supporting it natively.
   */
  neverUseShadowDOM?: boolean;
  /**
   * Disables shared css injection
   */
  neverInjectGlobalCss?: boolean;

  /**
   * Includes credentials to fetch configuration
   */
  includeCredentialsWhenFetchingConfiguration?: boolean;
  /**
   * Includes core-js/es polyfills
   */
  includePolyfills?: boolean;
}


/**
 * Options that can be used to adjust how your widgets is configured.
 * Pass it to the `createWidgetConfiguration` function.
 */
export interface WidgetConfigurationOptions {
  /**
   * Disables ShadowDOM usage even in browsers that are supporting it natively.
   */
  neverUseShadowDOM?: boolean;
  /**
   * Disables shared css injection
   */
  neverInjectGlobalCss?: boolean;

  /**
   * Includes credentials to fetch configuration
   */
  includeCredentialsWhenFetchingConfiguration?: boolean;
  /**
   * Includes core-js/es polyfills
   */
  includePolyfills?: boolean;
}


export interface WidgetConfigurationProps {
  widgetConfiguration: IWidgetConfiguration;
}

export const WidgetConfigurationContext = React.createContext<
  WidgetConfigurationProps | undefined
>(undefined);

export type IWidgetConfigurationContext = React.ContextType<
  typeof WidgetConfigurationContext
>;
